import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "formButton" ]
  connect() {
  console.log("submit controller connected");
  }
  submitForm() {
    // Trigger the form submission when the user types in the form
    console.log("submitting form");
    this.formButtonTarget.click();
  }
}
